import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

import { trackPublicEvent } from "@/features/analytics/api";
import type { EventPrefix } from "@/features/analytics/models";
import {
  CUSTOMER_IO_EVENT,
  EVENT_PREFIX,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers";
import type { OnboardingUser } from "@/features/onboarding/models";
import { parsePhoneNumber } from "@/shared/utils/phone-number";

interface TrackPlanPageViewedParams {
  customerIoAnalytics: AnalyticsBrowser;
  user: OnboardingUser;
  eventPrefix?: EventPrefix;
}

export const trackPlanPageViewed = ({
  customerIoAnalytics,
  user,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackPlanPageViewedParams) => {
  triggerGoogleTagManagerTracking({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.PLAN_PAGE_VIEWED}`,
  });

  if (!user?.email) {
    return;
  }

  void customerIoAnalytics.identify(user.email, {
    ...user,
    email: user.email,
    phone: parsePhoneNumber(user?.phoneNumber ?? ""),
    source: window.location.href,
  });

  trackPublicEvent({
    event: `${eventPrefix}${CUSTOMER_IO_EVENT.PLAN_PAGE_VIEWED}`,
    properties: { source: window.location.href },
    userId: user.email,
  });
};
